// Módulo vazio tipado para dependências que não funcionam no web

export interface EmptyModule {
  [key: string]: any
}

const emptyModule: EmptyModule = new Proxy(
  {},
  {
    get: () => () => {},
    set: () => true,
    has: () => true,
    ownKeys: () => [],
    getOwnPropertyDescriptor: () => ({ enumerable: true, configurable: true }),
  },
)

export default emptyModule
